<template>
    <div class="about-fullpage about">
        <div class="section about">
            <div class="container">
                <div class="d_table_cell t_about_768 w_60 relative">
                    <div class="circles_about" ></div>
                    <h2>{{ $t('sections.about.first_title') }}</h2>
                    <p>{{{ $t('sections.about.first_location') }}}</p>
                    <p>{{{ $t('sections.about.first_text') }}}</p>
                </div>
                <div class="d_table_cell t_about_768 t_center">
                    <div class="guco_about">
                        <img src="../assets/images/logo_guco_transp.png" alt="Logo Guco" class="img-responsive">
                    </div>
                </div>
            </div>
        </div>
        <div class="section estrutura">
            <div class="container">
                <div class="d_table h_100 structure_detail">
                    <div class="d_table_cell structure_img">
                        <div class="row">
                            <div class="col-md-offset-4 col-md-8">
                                <h2 class="c_white title_estrutura">{{ $t('sections.about.second_title') }}</h2>
                                <p class="c_white">{{ $t('sections.about.second_text') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section bg_pracamaior">
            <div class="container">
                <div class="d_table h_100" style=" margin: 0 auto; width: 50%;">
                    <div class="d_table_cell t_center">
                        <div class="row">
                            <div class="col-md-offset-3 col-md-6">
                                <div class="circles_ux"></div>
                                <p class="m_b_40">{{ $t('sections.about.third_title') }}</p>
                                <h2>{{ $t('sections.about.third_text') }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="section">-->
            <!--<div class="position">-->
                <!--<div class="top top"></div>-->
                <!--<div class="right top"></div>-->
                <!--<div class="right center"></div>-->
                <!--<div class="right bottom"></div>-->
                <!--<div class="center bottom"></div>-->
                <!--<div class="left top"></div>-->
                <!--<div class="center top"></div>-->
                <!--<div class="center top"></div>-->
                <!--<div class="center top"></div>-->
            <!--</div>-->

            <!--TEAM-->

            <!--<section class="team">-->
                <!--<div class="container">-->
                    <!--<h1 class="title_team">Nosso Time</h1>-->
                    <!--<div class="d_table">-->
                        <!--<div class="d_table_cell table_425 w_20 nav nav-tabs">-->
                            <!--<ul class="list_team">-->
                                <!--<li> <a href="#01" data-toggle="tab"> <img src="../assets/images/equipe/inte.png" alt="" class="img-responsive"> </a> </li>-->
                                <!--<li> <a href="#02" data-toggle="tab"> <img src="../assets/images/equipe/inte.png" alt="" class="img-responsive"> </a> </li>-->
                                <!--<li> <a href="#03" data-toggle="tab"> <img src="../assets/images/equipe/inte.png" alt="" class="img-responsive"> </a> </li>-->
                                <!--<li> <a href="#04" data-toggle="tab"> <img src="../assets/images/equipe/inte.png" alt="" class="img-responsive"> </a> </li>-->
                                <!--<li> <a href="#05" data-toggle="tab"> <img src="../assets/images/equipe/inte.png" alt="" class="img-responsive"> </a> </li>-->
                                <!--<li> <a href="#06" data-toggle="tab"> <img src="../assets/images/equipe/inte.png" alt="" class="img-responsive"> </a> </li>-->
                                <!--<li> <a href="#07" data-toggle="tab"> <img src="../assets/images/equipe/inte.png" alt="" class="img-responsive"> </a> </li>-->
                            <!--</ul>-->
                        <!--</div>-->
                        <!--<div class="d_table_cell tab-content table_425 trans3" style="width: 80%">-->
                            <!--<div class="tab-pane fade active in w_100" id="01" role="tabpanel" >-->
                                <!--<div class="d_table">-->
                                    <!--<div class="d_table_cell">-->
                                        <!--<img src="../assets/images/equipe/bissolli.jpg" class="img-responsive img-rounded">-->
                                    <!--</div>-->
                                    <!--<div class="d_table_cell text-right">-->
                                        <!--<h2>Gustavo Bissolli</h2>-->
                                        <!--<span>Founder and Developer</span>-->
                                        <!--<blockquote>So Loco!</blockquote>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="tab-pane fade in w_100" id="02" role="tabpanel" >-->
                                <!--<div class="d_table">-->
                                    <!--<div class="d_table_cell">-->
                                        <!--<img src="../assets/images/equipe/lima.jpg" class="img-responsive img-rounded">-->
                                    <!--</div>-->
                                    <!--<div class="d_table_cell text-right">-->
                                        <!--<h2>Gustavo Lima</h2>-->
                                        <!--<span>Founder and Frontend Developer</span>-->
                                        <!--<blockquote>Japa, tem que rodar alguma coisa?</blockquote>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="tab-pane fade in w_100" id="03" role="tabpanel" >-->
                                <!--<div class="d_table">-->
                                    <!--<div class="d_table_cell">-->
                                        <!--<img src="../assets/images/equipe/japa.jpg" class="img-responsive img-rounded">-->
                                    <!--</div>-->
                                    <!--<div class="d_table_cell text-right">-->
                                        <!--<h2>Japa</h2>-->
                                        <!--<span>Developoer</span>-->
                                        <!--<blockquote>Na minha maquina funciona!</blockquote>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="tab-pane fade in w_100" id="04" role="tabpanel" >-->
                                <!--<div class="d_table">-->
                                    <!--<div class="d_table_cell">-->
                                        <!--<img src="../assets/images/equipe/fogaca.jpg" class="img-responsive img-rounded">-->
                                    <!--</div>-->
                                    <!--<div class="d_table_cell text-right">-->
                                        <!--<h2>Felipão</h2>-->
                                        <!--<span>Designer</span>-->
                                        <!--<blockquote>Tipo ........</blockquote>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="tab-pane fade in w_100" id="05" role="tabpanel" >-->
                                <!--<div class="d_table">-->
                                    <!--<div class="d_table_cell">-->
                                        <!--<img src="../assets/images/equipe/fogaca.jpg" class="img-responsive img-rounded">-->
                                    <!--</div>-->
                                    <!--<div class="d_table_cell text-right">-->
                                        <!--<h2>Cotto</h2>-->
                                        <!--<span>Front End Developer</span>-->
                                        <!--<blockquote>Falta só subi essa imagem</blockquote>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="tab-pane fade in w_100" id="06" role="tabpanel" >-->
                                <!--<div class="d_table">-->
                                    <!--<div class="d_table_cell">-->
                                        <!--<img src="../assets/images/equipe/pedro.jpg" class="img-responsive img-rounded">-->
                                    <!--</div>-->
                                    <!--<div class="d_table_cell text-right">-->
                                        <!--<h2>Pedro</h2>-->
                                        <!--<span>Developer</span>-->
                                        <!--<blockquote>Vamos fazer uma impressora 3d com peças do Ali Express</blockquote>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="tab-pane fade in w_100" id="07" role="tabpanel" >-->
                                <!--<div class="d_table">-->
                                    <!--<div class="d_table_cell">-->
                                        <!--<img src="../assets/images/equipe/murari.jpg" class="img-responsive img-rounded">-->
                                    <!--</div>-->
                                    <!--<div class="d_table_cell text-right">-->
                                        <!--<h2>Murari</h2>-->
                                        <!--<span>Sales Force</span>-->
                                        <!--<blockquote>É verdade, quem me contou foi um pescador</blockquote>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->

                    <!--</div>-->
                <!--</div>-->

        <!---->
            <!--</section>-->
        <!--</div>-->
    </div>
</template>

<script>
    import Vue from 'vue'
    import jQuery from 'jquery'
    import * as fullpage from 'fullpage.js/dist/jquery.fullpage'

    export default {
        name: 'About',
        data () {
            return {
                meta: {
                    title: 'Sobre a agência',
                    description: 'A Guco é uma agência situada em Sorocaba, que tem como foco trabalhar na criação e desenvolvimento de soluções para web',
                    pageUrl: 'http://www.guco.com.br/a-guco',
                }
            }
        },
        head: {
            title () {
                return {
                    inner: this.meta.title
                }
            },
            meta () {
                return {
                    // Basic meta
                    name: {
                        'description' : this.meta.description,
                        'twitter:title': this.meta.title + ' | ' + this.meta.appName,
                        'twitter:description': this.meta.description,
                    },
                    // Google+ / Schema.org
                    itemprop: {
                        name: this.meta.title + ' | ' + this.meta.appName,
                        description: this.meta.description,
                    },
                    // Facebook / Open Graph
                    property: {
                        'og:url': this.meta.pageUrl,
                        'og:title': this.meta.title + ' | ' + this.meta.appName,
                        'og:description': this.meta.description,
                    }
                }
            },
            link () {
            return {
                canonical: {
                    href: this.meta.pageUrl
                },
            }
        }
        },
        detached () {
            jQuery.fn.fullpage.destroy('all');
        },
        ready () {
            jQuery('.about-fullpage').fullpage({
                lockAnchors: true,
                css3: true,
                navigation: true,
                navigationPosition: 'right',
                responsiveWidth: 993,
                responsiveHeight: 500
            });
        },
    }
</script>



// WEBPACK FOOTER //
// About.vue?1dc7f119